import React from 'react';
import type { AgenticExecutionMetadata } from '@shared/agentic-execution';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { ShieldAlert } from 'lucide-react';

interface AgenticErrorNoticeProps {
  error?: AgenticExecutionMetadata['error'] | null;
  correlationId?: string | null;
  isAdmin: boolean;
}

const AgenticErrorNotice: React.FC<AgenticErrorNoticeProps> = ({
  error,
  correlationId,
  isAdmin,
}) => {
  if (!error) {
    return null;
  }

  const effectiveCorrelationId =
    correlationId ?? error?.correlationId ?? null;

  const adminMessage =
    error?.summary.message ??
    'Agentic orchestration reported an error for this response.';
  const userMessage =
    'We paused this reply because one of the AI tools ran into a problem. Please try again or share the reference ID with an administrator.';

  return (
    <Alert variant="destructive" className="mt-3">
      <ShieldAlert className="h-4 w-4" aria-hidden />
      <AlertTitle>Tool execution issue</AlertTitle>
      <AlertDescription className="space-y-2 text-sm">
        <p>{isAdmin ? adminMessage : userMessage}</p>
        {effectiveCorrelationId && (
          <p className="text-xs font-mono uppercase tracking-wide">
            Reference ID:{' '}
            <span className="font-semibold">{effectiveCorrelationId}</span>
          </p>
        )}
      </AlertDescription>
    </Alert>
  );
};

export default AgenticErrorNotice;
